module.exports = __webpack_public_path__ + "static/img/collapse_l.4aabd96b.svg";